import script from "./productGroupsBasic.vue?vue&type=script&lang=ts&setup=true"
export * from "./productGroupsBasic.vue?vue&type=script&lang=ts&setup=true"

import "./productGroupsBasic.vue?vue&type=style&index=0&id=25c731b1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c731b1"]])

export default __exports__